/* eslint-disable @typescript-eslint/no-empty-function */
import { CSSProperties, FC, createContext, useMemo, useContext } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { RowProps } from 'antd/lib/row'
import { DraggableSyntheticListeners } from '@dnd-kit/core'
import Icon from 'antd/lib/icon'
import classNames from 'classnames'

interface Context {
  attributes: Record<string, any>
  listeners: DraggableSyntheticListeners
  ref: (node: HTMLElement | null) => void
}

const SortableRowContext = createContext<Context>({
  attributes: {},
  listeners: undefined,
  ref: () => {},
})

export const DraggableTableRow: FC<RowProps> = (props) => {
  const rowId = props['data-row-key']

  const { setNodeRef, attributes, listeners, transition, transform, isDragging, setActivatorNodeRef } = useSortable({
    id: rowId,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  })

  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef,
    }),
    [attributes, listeners, setActivatorNodeRef],
  )

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <SortableRowContext.Provider value={context}>
      <tr ref={setNodeRef} {...props} style={style} className={classNames({ dragging: isDragging })}>
        {props.children}
      </tr>
    </SortableRowContext.Provider>
  )
}

export const DragHandle: FC = () => {
  const { attributes, listeners, ref } = useContext(SortableRowContext)

  return (
    <button ref={ref} {...attributes} {...listeners} className="drag-button">
      <Icon type="menu" />
    </button>
  )
}
